import { onboardingApi, UserProfile } from '../api/onboardingApi';

export function getOnboardingRedirectPath(profile: UserProfile): string | null {
  const { onboarding, has_preferences, has_resume, sessions } = profile;

  if (!has_preferences || onboarding.status === 'pending_preferences') {
    return '/onboarding/preferences';
  }
  if (!has_resume || onboarding.status === 'pending_resume') {
    return '/onboarding/resume';
  }
  if (
    onboarding.status === 'pending_first_session' ||
    (has_resume && sessions.length === 0)
  ) {
    return '/onboarding/resume';
  }

  return null;
}

export function clearPostLoginStorage(): void {
  sessionStorage.removeItem('loginEmail');
  sessionStorage.removeItem('demoMode');
  localStorage.removeItem('preferencesCompleted');
  localStorage.removeItem('userPreferences');
}

export async function resolvePostLoginPath(): Promise<string> {
  try {
    const profileResponse = await onboardingApi.getUserProfile();
    return getOnboardingRedirectPath(profileResponse.data) ?? '/candidate';
  } catch (error: unknown) {
    const status = (error as { response?: { status?: number } })?.response?.status;
    if (status === 404) {
      return '/onboarding/preferences';
    }
    console.error('Failed to fetch user profile for post-login redirect:', error);
    return '/onboarding/preferences';
  }
}
